import * as React from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";

import { ObjValidator } from "components";

const LibraryTemplates = Scrivito.connect(({ page }) => (
  <div className="pt-4 bg-gray-100">
    <Container className="pb-8">
      <Scrivito.ContentTag
        className="text-uppercase"
        content={page}
        attribute="title"
        tag="h3"
      />
      <Scrivito.ContentTag content={page} attribute="subtitle" tag="h4" />
      <Scrivito.ContentTag content={page} attribute="body" />
    </Container>
  </div>
));

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <LibraryTemplates {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("LibraryTemplates", CheckedPage);
